module.exports = __webpack_public_path__ + "img/efren.a3192c04.png";